module.exports = __webpack_public_path__ + "img/coffee.f9049ff0.svg";